// extracted by mini-css-extract-plugin
module.exports = {"namesList":"NamesList_namesList__34VtO","namesListItem":"NamesList_namesListItem__3Mbgd"};